import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EventNotificationUpdateInfo } from '../models/event-notifications/event-notification-update-info.model';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable()
export class EventNotificationService {
    private readonly apiController = 'api/eventnotification';

    constructor(private readonly httpService: HttpClient) { }

    public getNotifications(itemsToSkip: number): Observable<EventNotificationUpdateInfo> {
        return this.httpService.get(`${this.apiController}/notifications/${itemsToSkip}`) as Observable<EventNotificationUpdateInfo>;
    }

    public deleteEventNotification(notificationId: number) {
        return this.httpService.delete(`${this.apiController}/delete/${notificationId}`).pipe(distinctUntilChanged());
    }

    public deleteAllEventNotifications() {
        return this.httpService.delete(`${this.apiController}/delete/all`);
    }

    public readEventNotification(notificationId: number) {		
        return this.httpService.get(`${this.apiController}/read/${notificationId}`).pipe(distinctUntilChanged());		
    }
}